import { Checkbox, Input } from "antd"
import Modal from "antd/es/modal/Modal"
import '../styles.scss'
import { IRelative } from "../../../api/selectOptions/selectOptionsApi"
import { useEffect, useState } from "react"

export interface ISLModalFilter {
  id: number | string;
  title: string;
}

interface ModalProp {
  isOpen: boolean
  columnCode: string
  checkShowSearch: boolean
  sLData: ISLModalFilter[]
  selectedValues: (string | number)[]
  scrollRef: any

  handleSearch: (search?: string) => void
  handleFilterColumnSelectChange: (columnCode: string, value: (string | number)[]) => void,
  onPopupScroll?: (e: React.UIEvent<HTMLDivElement, UIEvent>, columnId: string) => void
  closeModal: (isClose: boolean) => void
}
const ModalFilter: React.FC<ModalProp> = ({
  isOpen, columnCode, sLData, checkShowSearch,
  selectedValues = [], scrollRef,
  handleSearch, handleFilterColumnSelectChange, onPopupScroll, closeModal,

}) => {

  const [selectedValueTmp, setSelectedValueTmp] = useState<(string | number)[]>([])

  const handleConfirm = () => {

    handleFilterColumnSelectChange(columnCode, selectedValueTmp)
    closeModal(false)
  }

  useEffect(() => {
    if (isOpen) {
      setSelectedValueTmp(selectedValues)
    } else {
      setSelectedValueTmp([])
    }
  }, [isOpen])

  return (
    <Modal
      open={isOpen}
      title={false}
      footer={false}
      closeIcon={false}
      onCancel={() => closeModal(false)}
      className="w-modal-242"
    >
      <div className={`d-flex flex-column shadow-dropdown-fliter`}>
        {
          !checkShowSearch ? <></>
            : <div className="p-1">
              <Input
                placeholder="Tìm kiếm "
                allowClear
                onChange={(e) => handleSearch(e.target.value === "" ? undefined : e.target.value)}
                onClear={() => handleSearch(undefined)}
              />
            </div>
        }

        <div
          className={`d-flex flex-column gap-2 p-3  ${sLData.length >= 7 ? "h-230-px overflow-y-scroll" : ""}`}
          ref={(el) => {
            scrollRef.current[columnCode] = el;
          }}
          onScroll={(e) => onPopupScroll?.(e, columnCode)}
        >
          {
            sLData.map((item, i) => (
              <Checkbox
                key={i}
                checked={selectedValueTmp?.includes(item.id)}
                onChange={(e) => {
                  const checked = e.target.checked;
                  const newValue = item.id;
                  if (checked) {
                    setSelectedValueTmp(prev => [...prev, newValue]);
                  } else {
                    setSelectedValueTmp(prev => prev.filter(id => id !== newValue));
                  }
                }}
                className="size-check-box size-check-box-inner p-checkbox icon-check-box">
                <span className="text-sm font-regular fw-400">{item.title}</span>
              </Checkbox>
            ))
          }




        </div>
        <div className='d-flex justify-between p-2 border-t-F0F0F0'>
          <button
            onClick={() => setSelectedValueTmp([])}
            className={`${selectedValueTmp?.length ? 'text-c40d0d' : 'text-BFBFBF'} border-none bg-white text-sm font-regular `} >
            Làm mới
          </button>
          <button
            onClick={handleConfirm}
            className='border-none bg-096DD9 text-sm rounded-2 h-8 px-7-px font-regular text-white'>
            Xác nhận
          </button>
        </div>
      </div>

    </Modal>
  )
}
export default ModalFilter
